import { render, staticRenderFns } from "./dietDurationPrice.vue?vue&type=template&id=3a362a16"
import script from "./dietDurationPrice.vue?vue&type=script&lang=js"
export * from "./dietDurationPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports